
export class InvoiceApprovalRequestModel {
    approvalUrl?: string;
    approvalUserId?: string;
    myfileId?: string;
    requisitionId?: string;
}